/**
 * 聚合 store 模块
 */
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

const modules = {};
const context = require.context('./', true, /\.js$/);
context
  .keys()
  .filter(item => item !== './index.js')
  .map((key) => {
    // uglifyjs error
    // const namespace = key.match(/(?<=\.\/).*?(?=\.js)/)
    const namespace = key.replace(/(\.\/)|(\.js)/g, '');
    const module = context(key).default;
    modules[namespace] = {
      namespaced: true,
      ...module,
    };
  });
Vue.use(Vuex);
const store = new Vuex.Store({
  modules,
  getters,
});

export default store;
